<template>
  <div>
    <Navbar />
    <div style="">
      <router-view />
      <Footer />
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import Navbar from './components/SiteNavbar.vue';
import Footer from './components/SiteFooter.vue';

export default {
  components: { Navbar, Footer },
  setup() {
    useHead({
      title: "Learn English in Petaling Jaya, Malaysia | To Learn English",
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' },
        { name: 'theme-color', content: '#ffffff', media: '(prefers-color-scheme: light)' },
        { name: 'theme-color', content: '#ffffff', media: '(prefers-color-scheme: dark)' },
        { name: 'description', content: 'Learn to speak English with English Matters, a Language Centre in Petaling Jaya with classes for kids, teens & adults in English speaking & correct grammar.' },
        { name: 'robots', content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1' },
        { name: 'google-site-verification', content: 'jLLfdgJCv_nmjaQz4RA_XzM6a4b5QLwmkz18u0tUgJY' },
        { property: 'og:url', content: 'https://ukenglishmatters.com/' },
        { property: 'og:site_name', content: 'Learn English in Petaling Jaya, Malaysia | To Learn English' },
        { property: 'og:locale', content: 'en_GB' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Learn English in Petaling Jaya, Malaysia | To Learn English' },
        { property: 'og:description', content: 'Learn to speak English with English Matters, a Language Centre in Petaling Jaya with classes for kids, teens & adults in English speaking & correct grammar.' },
        { property: 'og:image', content: 'https://ukenglishmatters.com/wp-content/uploads/2024/03/knowledge-graph-banner.webp' },
        { property: 'og:image:secure_url', content: 'https://ukenglishmatters.com/wp-content/uploads/2024/03/knowledge-graph-banner.webp' },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { property: 'og:image:alt', content: 'knowledge graph banner' },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: 'https://www.twitter.com/UKEngMatters' },
        { name: 'twitter:creator', content: 'https://www.twitter.com/UKEngMatters' },
        { name: 'twitter:title', content: 'Learn English in Petaling Jaya, Malaysia | To Learn English' },
        { name: 'twitter:description', content: 'Learn to speak English with English Matters, a Language Centre in Petaling Jaya with classes for kids, teens & adults in English speaking & correct grammar.' },
        { name: 'twitter:image', content: 'https://ukenglishmatters.com/wp-content/uploads/2024/03/knowledge-graph-banner.webp' },
      ],
      link: [
        { rel: 'shortcut icon', href: 'https://english-matters.s3.ap-southeast-1.amazonaws.com/favicon.png', type: 'image/x-icon' },
        { rel: 'canonical', href: 'https://ukenglishmatters.com/' }
      ],
    });
  }
};
</script>